import { render, staticRenderFns } from "./CreateScreenSaver.vue?vue&type=template&id=19ce704a&scoped=true&"
import script from "./CreateScreenSaver.vue?vue&type=script&lang=ts&"
export * from "./CreateScreenSaver.vue?vue&type=script&lang=ts&"
import style0 from "./CreateScreenSaver.vue?vue&type=style&index=0&id=19ce704a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ce704a",
  null
  
)

export default component.exports